// extracted by mini-css-extract-plugin
export var alternate = "_e-h";
export var black = "_e-3";
export var blue = "_e-d";
export var blueLight = "_e-c";
export var brand = "_e-7";
export var error = "_e-9";
export var gray = "_e-6";
export var grayBlue = "_e-b";
export var iconWrapper = "_e-4";
export var indigo = "_e-e";
export var orange = "_e-g";
export var pink = "_e-f";
export var primary = "_e-0";
export var purple = "_e-8";
export var success = "_e-5";
export var warning = "_e-a";
export var white = "_e-1";
export var whiteSuccess = "_e-2";